<template>
  <div style="background-color: #f6f6f6">
    <!-- 头部导航 -->
    <Header />
    <!-- 轮播图区域 -->
    <div
      style="
        position: relative;
        width: 100%;
        padding-top: 37.5%;
        overflow: hidden;
      "
    >
      <el-carousel
        trigger="click"
        style="position: absolute; top: 0; left: 0; right: 0; bottom: 0"
      >
        <el-carousel-item v-for="(item, index) in imglist.banner" :key="index">
          <img
            :src="item.thumb"
            alt=""
            style="height: 100%; width: 100%; object-fit: cover"
          />
          @click="goToTargetPage(item)" />
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="home-container">
      <!-- 欢迎语区域 -->
      <div class="welcome-section">
        <img src="../assets/welcome-1.png" alt="" />
      </div>

      <!-- 三大板块区域 -->
      <el-row :gutter="30" class="cards-section">
        <el-col :span="8" v-for="(item, index) in imglist.body" :key="index">
          <el-card class="home-card" :body-style="{ padding: '0' }">
            <div @click="goTo(item)">
              <img :src="item.thumb" :alt="item.title" class="card-img" />
              <div class="name">
                <img :src="item.images" alt="" />
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- 底部 -->
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { indexHome } from "@/api/index";
export default {
  name: "HzydgwHome",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      imglist: "",
      a: "http://foherbcn.hzyddzsw.com/",
      carouselHeight: "70vh", // 默认高度为视口的50%
    };
  },

  mounted() {
    // 监听窗口 resize 事件，动态调整高度（可选）
    window.addEventListener("resize", this.handleResize);
    // 初始化时执行一次
    this.handleResize();
    this.getindex();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    //跳转详情
    goToTargetPage(item) {
      console.log(item);

      this.$router.push({
        path: `/about?id=${item.cdetail_id}&unit_id=${item.unit_id}`, // 将id拼接到路由路径中
      });
    },
    goTo(item) {
      console.log(item);

      this.$router.push({
        path: `/news?id=${item.clist_id}&unit_id=${item.unit_id}`, // 将id拼接到路由路径中
      });
    },
    //首页
    getindex() {
      indexHome().then((res) => {
        console.log(res);
        this.imglist = res;
      });
    },
    handleResize() {
      // 示例：在移动设备上降低高度
      if (window.innerWidth < 768) {
        this.carouselHeight = "50vh";
      } else {
        this.carouselHeight = "70vh";
      }
    },
  },
};
</script>
<style scoped lang="scss">
.name {
  width: 210px;
  height: 90px;
  position: absolute;
  top: 50%; /* 垂直方向距离父容器顶部50% */
  left: 50%; /* 水平方向距离父容器左侧50% */
  transform: translate(-50%, -50%); /* 向左、向上移动自身一半尺寸，实现居中 */
  background: rgba(226, 220, 206, 0.6);
  font-size: 18px;
  text-align: center;

  padding: 20px;
  img {
    width: 100%;
    transition: 0.5s;
  }
}
.home-card:hover img {
  transform: scale(1.05);
  opacity: 0.6;
}
.carousel-container {
  width: 100%;
  overflow: hidden;
}
::v-deep .el-carousel__container {
  height: 100%;
}
.el-carousel {
  height: 100%;
}
/* 核心样式：图片自适应容器 */
.carousel-img {
  width: 100%;
  height: 100%;
  /* 保持图片比例并填充容器（可能裁剪边缘） */
  object-fit: cover;
  /* 可选：若希望完整显示图片（可能有留白），用 object-fit: contain; */
}

/* 优化指示器样式（可选） */
::v-deep .el-carousel__indicators {
  bottom: 20px;
}

.home-container {
  background-color: #fff;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding-bottom: 60px;
}

/* 轮播图样式 */
.el-carousel {
  position: relative;
}
.carousel-bg {
  width: 100%;
  height: 300px;
  object-fit: cover;
}
.carousel-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #fff;
}
.company-logo,
.huawei-logo {
  display: inline-block;
  vertical-align: middle;
  margin: 0 10px;
}
.carousel-content h2 {
  font-size: 28px;
  margin-top: 15px;
}

/* 欢迎语样式 */
.welcome-section {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 50px 0;
}
.divider {
  width: 80px;
  height: 2px;
  background-color: #c69749;
  margin: 0 15px;
}
.welcome-eng {
  font-size: 20px;
  color: #c69749;
}
.welcome-cn {
  font-size: 24px;
  width: 100%;
  text-align: center;
  margin-top: 10px;
}

/* 卡片样式 */
.cards-section {
  margin-bottom: 40px;
}
.home-card {
  position: relative;
  height: 280px;
  overflow: hidden;
}
.card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: 0.5s;
}
.card-overlay {
  position: relative;
  top: -50px;
  width: 120px;
  margin: 0 auto;
  text-align: center;
  background-color: rgba(245, 240, 230, 0.9);
  padding: 10px;
}
.card-overlay p:first-child {
  font-size: 18px;
  margin-bottom: 5px;
}
.card-overlay p:last-child {
  font-size: 14px;
}
</style>
